import React, { useState, useEffect } from "react";
import lowVolume from "assets/img/icons/low-volume.svg";
import midVolume from "assets/img/icons/mid-volume.svg";
import highVolume from "assets/img/icons/high-volume.svg";
import closeVolume from "assets/img/icons/close-volume.svg";
import reminder from "assets/img/reminder.jpg";
import TeamService from "services/TeamService";
import classNames from "classnames";
import Loader from "components/Loader";
import { useToasts } from "react-toast-notifications";
import "assets/scss/helpers/engagement.scss";
import { Modal } from "react-responsive-modal";
import { ReactComponent as EngagementIcon } from "assets/img/icons/engagement-parrot.svg";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { useTeamContext } from "store/contexts/teamContext";

export default () => {
  const { team } = useTeamContext();
  const { addToast } = useToasts();
  const [dialogState, setDialogState] = useState(false);
  const [activeEngagement, setActiveEngagement] = useState(
    team?.profile?.level_of_engagement?.id ?? 1
  );
  const [engagementOptions, setEngagementOptions] = useState();
  const [volumeImage] = useState([
    closeVolume,
    lowVolume,
    midVolume,
    highVolume,
  ]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const response = await TeamService.getListLevelOfEngagement();

        setEngagementOptions(response?.data?.data);
        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [team]);

  const showActiveEngagement = (key) => {
    return classNames({
      dialogContent: true,
      allowedContent: team?.role_id === 2 ? true : false,
      notAllowedContent: team?.role_id === 2 ? false : true,
      activeEngagementContent: key === activeEngagement && true,
    });
  };

  const changeEngagement = async (typeKey) => {
    try {
      setActiveEngagement(typeKey);

      await TeamService.postLevelEngagement(team.id, typeKey);

      addToast("Your reminder has been changed ", { appearance: "success" });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div onClick={() => setDialogState(true)} style={{ cursor: "pointer" }}>
        <EngagementIcon className="mx-2" />
        <span>Level Of Engagment</span>
      </div>
      <Modal
        classNames={{
          modalContainer: "modalContainer",
          modal: "engagementModal",
        }}
        open={dialogState}
        showCloseIcon={false}
        onClose={() => setDialogState(false)}
      >
        <div className="titleRoot">
          <div className="headingTitleEngagement">
            <h5 className="headingEngagement">Level of Engagment</h5>
            <span className="engagementCloseIcon">
              <CancelIcon onClick={() => setDialogState(false)} />
            </span>
          </div>
        </div>
        <div className="contentRoot">
          <div className="engagmentInformation">
            <div className="contentContext">
              ReTeam helps you and your team engage at the level that is best
              for your team. Setting the Level of Engagement will help your team
              better utilize the activities in ReTaem
            </div>
            <div className="engagementContext">
              (Team Video, Slideshow, Bright ideas, Wall of Fame, Topic of the
              Day, Check-ins, To-Do Lists, Textual engagements)
            </div>
          </div>
          {loading && (
            <div className="engagementLoader">
              <Loader />
            </div>
          )}
          {engagementOptions?.map((engagement) => (
            <div
              key={engagement?.id}
              className={showActiveEngagement(engagement?.id)}
              onClick={
                team?.role_id === 2 && (() => changeEngagement(engagement?.id))
              }
            >
              <div className={"engagementContent"}>
                <img
                  src={volumeImage[engagement?.id - 1]}
                  alt={`${engagement?.name}`}
                />
              </div>
              <div className={"engagementsDescription"}>
                <h6 className={"engagementName"}>{engagement?.name}</h6>
                <span variant="body2" className={"engagementDescription"}>
                  {engagement?.description}
                </span>
              </div>
            </div>
          ))}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <img
              src={reminder}
              alt="reminder"
              style={{ width: "100%", maxWidth: "25vh" }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
